require('../../modules/es6.function.has-instance');
module.exports = require('../../modules/_wks-ext').f('hasInstance');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/has-instance.js
// module id = 453
// module chunks = 5 7 8 9 10 11 13 23 24 25 27 29 31 57 58